"use client";

import { Button } from "@faire/slate/components/button";
import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import { IActionProps } from "@faire/slate/private/shared/types";
import React from "react";

export const FilterMenuFooterAction: React.FC<IActionProps> = ({
  label,
  onClick,
  ...rest
}) => {
  const { setOpen } = useFloatingContext();

  return (
    <Button
      fullWidth
      size="small"
      {...rest}
      onClick={() => {
        onClick?.();
        setOpen(false);
      }}
    >
      {label}
    </Button>
  );
};
